/** Account type key for customer/supplier accounts in structure and search APIs. */
export const CUSTOMER_ACCOUNT_TYPE = "לקוח-ספק" as const;

/** Base route path for the customers browse page. */
export const CUSTOMERS_PATH = "/customers";

/** Default breadcrumb labels for the customers section. */
export const CUSTOMERS_BREADCRUMB = {
  ledger: "כרטסות",
  list: "לקוחות/ספקים",
} as const;

/** Breadcrumb labels for structure editor sub-pages. */
export const CUSTOMERS_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;

/** Inline styles for the search filters panel on the customers page. */
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
